import { FC } from "react";

import { SPARK_STROKE_WIDTH, SPARK_VIEWBOX } from "../investigation.constants";

/** A single-path SVG spark line (e.g. on-board count or speed over the playback window). */
export const InvestigationSparkline: FC<{ path: string; color: string }> = ({
  path,
  color,
}) => (
  <svg viewBox={SPARK_VIEWBOX} preserveAspectRatio="none">
    <path
      d={path}
      fill="none"
      stroke={color}
      strokeWidth={SPARK_STROKE_WIDTH}
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
